<template>
  <v-container id="HomePage" fluid tag="section">
    <v-app-bar color="#b88611" dense dark>
      <v-toolbar-title>Add a Product to the Inventory</v-toolbar-title>

      <v-spacer />
    </v-app-bar>
    <div>
      <v-row>
        <v-col cols="12" md="12">
          <base-material-card color="#455A64" class="px-5 py-3" title="Product Details">
            <v-card-text class="px-0 pb-0">
              <v-sheet />

              <label for="name">Name</label>
              <v-text-field v-model="name" label="Name of the product" required />
              <label for="name">Description</label>
              <v-text-field v-model="desc" label="Description of the product" required />
              <v-row>
                <v-col cols="6" md="6">
                  <label for="name">Barcode</label>
                  <v-text-field v-model="barcode" label="Scan your barcode" required type="number" />
                </v-col>
                <v-col cols="6" md="6">
                  <label for="name">Quantity</label>
                  <v-text-field v-model="qty" label="How much you have" required type="number" />
                </v-col>
              </v-row>
              <div class="my-2">
                <v-btn large color="#55aa55" @click="insertt">
                  Insert
                </v-btn>
              </div>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
      <!-- -----------------------Loader---------------------- -->
      <v-row>
        <v-dialog v-model="loader" persistent width="200">
          <v-card>
            <v-card-text>
              <v-container>
                <v-row class="justify-center">
                  Adding, Please Wait...
                </v-row>
                <v-row class="mt-2 justify-center">
                  <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import db from './api/firebaseInit';
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import VueSimpleAlert from 'vue-simple-alert';

Vue.use(VueSimpleAlert, VueCookies);

export default {
  data: function () {
    return {
      dataReady: false,
      barcode: '',
      name: '',
      desc: '',
      qty: '',
      loader: false,
    };
  },
  mounted() {
    if (!VueCookies.get('maman')) {
      this.$router.push('/');
    }
  },
  methods: {
    insertt: function (e) {
      if (this.barcode != '' && this.name != '' && this.qty != '' && this.qty != '' && this.qty >= 0) {
        this.loader = true;
        const data = {
          barcode: this.barcode,
          name: this.name,
          description: this.desc,
          quantity: this.qty,
          inStock: this.qty,
        };
        db.collection('items')
          .doc()
          .set(data)
          .then(() => {
            this.$alert('Item added Successfully', '', 'success');
            this.barcode = '';
            this.name = '';
            this.desc = '';
            this.qty = '';
            this.loader = false;
          });
      }
    },
  },
};
</script>
